// DEFAULT_DIACRITICS_MAP could be removed by use of "normalize" function introduced since ES6
import { DEFAULT_DIACRITICS_MAP } from './defaultDiacriticsMap'

function removeDiacritics(str) {
  const diacriticsMap = {}
  for (let i = 0; i < DEFAULT_DIACRITICS_MAP.length; i += 1) {
    const { letters } = DEFAULT_DIACRITICS_MAP[i]
    for (let j = 0; j < letters.length; j += 1) {
      diacriticsMap[letters[j]] = DEFAULT_DIACRITICS_MAP[i].base
    }
  }
  return str.replace(/[^\\u0000-\\u007E]/g, (a) => diacriticsMap[a] || a)
}

export const slugify = (str) => {
  const slugified = String(removeDiacritics(str))
    // .normalize('NFKD') // (since ES6) split accented characters into their base characters and diacritical marks
    .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
    .trim() // trim leading or trailing whitespace
    .toLowerCase() // convert to lowercase
    .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
    .replace(/\s+/g, '-') // replace spaces with hyphens
    .replace(/-+/g, '-') // remove consecutive hyphens
  return slugified
}
